/**
 * Created by shubham on 19/9/18.
 */

import {Component, Input,ViewChild} from '@angular/core';
import {APPCONFIG} from '../../../config';
import {MdDialog} from '@angular/material';
import {FormGroup, FormBuilder, FormControl, Validators, FormArray} from '@angular/forms';
import {HttpService} from '../../../shared/services/http.service';
import {SessionHandler} from '../../../shared/services/session-handler.service';
import {DialogComponent} from '../../../dialog/dialog.component';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from 'ng2-translate';
import { IfObservable } from 'rxjs/observable/IfObservable';
import { concatAll } from 'rxjs/operator/concatAll';


@Component({
    selector: 'add-application',
    template: require('./addApplication.component.html')
})
export class AddApplicationComponent {

    dialogRef;
    userDetails: any;
    isSystemAdmin: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    isApplicationManager: boolean = false;
    admins = [];
    countries = [];
    businessUnits = [];
    ApplicationForm: FormGroup;
    ApplicationFormDetails: any;
    ApplicationFormDetailsById = [];
    managers = [];
    settings = {};
    selectedItems = [];
    managersMessage: string = "";
    id: any;
    managersFlag: boolean = false;
    idFlag: boolean = false;
    activeFlag: boolean = false;
    isAssigned: boolean = false;
    allowMultipleRolesFlag: boolean = false;
    skipManagerApprovalFlag: boolean = false;
    skipManagerApprovalMessage = "";

    selectedCountryId = "";
    countryWiseDefaults:any=[];

    @ViewChild('countrySelect') countrySelect: any;

    constructor(private router: Router, private route: ActivatedRoute, private sessionHandler: SessionHandler, public httpService: HttpService,
                public dialog: MdDialog, private formBuilder: FormBuilder, private translate: TranslateService) {
        this.route.params.subscribe(params => {
            this.id = params['id'];
        });

        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
        } else {
            this.httpService.noUserError();
        }

        if (this.isSystemAdmin) {
            if (this.id != null && this.id != undefined) {
                this.getApplicationDataById(this.id);
                this.idFlag = true;
            } else {
                this.activeFlag = true;
                this.idFlag = false;
            }
            this.getApplicationManagers();
        }
        this.getCountries()
    }

    public getApplicationManagers() {
        this.httpService.getRequest('applicationOperationApi/v1/getApplicationManagerList').subscribe(
            res => {
                this.saveApplicationManagers(res);
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveApplicationManagers(res) {
        if (res && res.items) {
            this.managers = res.items;
        }
        this.httpService.onEnd();
    }

    public getApplicationDataById(id) {
        this.httpService.getRequest('applicationOperationApi/v1/application/' + id).subscribe(
            res => {
                this.saveApplicationDataById(res)
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveApplicationDataById(res) {
        if (res) {
            console.log(res);
            /**************************/
            // var applicationRoles=[];
            // for(let i in res.applicationRoles) {
            //     for(let j in res.applicationRoles[i].roles) {
            //         res.applicationRoles[i].roles[j].country=res.applicationRoles[i].country;
            //         applicationRoles.push(res.applicationRoles[i].roles[j]);
            //     }
            // }
            // delete res.applicationRoles;
            // res.applicationRoles=applicationRoles;
            /**************************/

            this.ApplicationFormDetailsById = res;
            this.forSpecificCountry = res.countrySpecificRoles;
            if (this.ApplicationFormDetailsById['active']) {
                this.activeFlag = true;
            }

            if (this.ApplicationFormDetailsById['managerIds'] && this.ApplicationFormDetailsById['managerNames']) {
                for (let l in this.ApplicationFormDetailsById['managerIds']) {
                    this.selectedItems.push({
                        id: this.ApplicationFormDetailsById['managerIds'][l],
                        name: this.ApplicationFormDetailsById['managerNames'][l]
                    });
                }
            }
            this.buildForm();
            if (this.ApplicationFormDetailsById['applicationRoles'] != null) {
                if (this.ApplicationFormDetailsById['assigned'] || this.ApplicationFormDetailsById['assigned'] != undefined) {
                    this.isAssigned = true;
                } else {
                    this.isAssigned = false;
                }
                // ***÷*****************************
                
                this.createRoles(this.ApplicationFormDetailsById['applicationRoles'], this.isAssigned);
            }

            this.httpService.onEnd();
        } else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_load_failed';
            this.httpService.onEnd();
        }
    }

    buildForm() {
        this.ApplicationForm = this.formBuilder.group({
            applicationName: this.formBuilder.control(this.ApplicationFormDetailsById['applicationName'] ? this.ApplicationFormDetailsById['applicationName'] : null, [Validators.required]),
            ldapApplicationId: this.formBuilder.control(this.ApplicationFormDetailsById['ldapApplicationId'] ? this.ApplicationFormDetailsById['ldapApplicationId'] : null, [Validators.required]),
            managerData: this.formBuilder.control(null, [Validators.required]),
            url: this.formBuilder.control(this.ApplicationFormDetailsById['url'] ? this.ApplicationFormDetailsById['url'] : null),
            applicationRoles: this.formBuilder.array([]),
            multipleRole: this.formBuilder.control(this.ApplicationFormDetailsById['multipleRole'] ? this.ApplicationFormDetailsById['multipleRole'] : false),
            customerNumberRequired: this.formBuilder.control(this.ApplicationFormDetailsById['customerNumberRequired'] ? this.ApplicationFormDetailsById['customerNumberRequired'] : false),
            skipManagerApproval: this.formBuilder.control(this.ApplicationFormDetailsById['skipManagerApproval'] ? this.ApplicationFormDetailsById['skipManagerApproval'] : false),       
            countries: this.formBuilder.array([])
        });

        this.ApplicationForm.valueChanges.subscribe(data => {
            this.ApplicationFormDetails = this.ApplicationForm.getRawValue();
            if (this.ApplicationFormDetailsById['id']) {
                this.ApplicationFormDetails['id'] = this.ApplicationFormDetailsById['id'];
            }

            this.ApplicationFormDetails['managerIds'] = [];
            for (let d in this.ApplicationFormDetails.managerData) {
                this.ApplicationFormDetails['managerIds'].push(this.ApplicationFormDetails.managerData[d]['id']);
            }

            if (this.ApplicationFormDetails['skipManagerApproval']) {
                this.skipManagerApprovalFlag = true;
            } else {
                this.skipManagerApprovalFlag = false;
            }

            if (this.ApplicationFormDetails['multipleRole']) {
                this.allowMultipleRolesFlag = true;
                if (this.skipManagerApprovalFlag) {
                    this.skipManagerApprovalMessage = "min_one_default_role";
                } else {
                    this.skipManagerApprovalMessage = "";
                }
            } else {
                this.skipManagerApprovalMessage = "only_one_default_role";
                this.allowMultipleRolesFlag = false;
            }

            if (this.ApplicationFormDetails['applicationRoles'].length > 0) {
                for (let appRolesObject of this.ApplicationFormDetails['applicationRoles']) {
                    if (appRolesObject['defaultRole']) {
                        this.skipManagerApprovalMessage = "";
                        break;
                    } else {
                        if (this.allowMultipleRolesFlag) {
                            this.skipManagerApprovalMessage = "min_one_default_role";
                        } else {
                            this.skipManagerApprovalMessage = "only_one_default_role";
                        }
                    }
                }
            }

            // ************************************
            if(this.ApplicationFormDetails['countries']){
                setTimeout(()=>{
                    if(this.forSpecificCountry && this.selectedContries.length==0){
                        this.skipManagerApprovalMessage = "Select at least one country."
                    }
                    if(this.forSpecificCountry && this.selectedContries.length>0 && this.skipManagerApprovalFlag){
                        for(var i=0;i<this.ApplicationFormDetails.countries.length;i++){
                           for(var j=0;j<this.ApplicationFormDetails.countries[i].countryName.length;j++){                   
                                if(this.ApplicationFormDetails.countries[i].countryName[j]['defaultRole']){
                                    this.skipManagerApprovalMessage = "";
                                    break;
                                }
                                else{
                                    if (this.allowMultipleRolesFlag) {
                                        this.skipManagerApprovalMessage = "min_one_default_role";
                                    } else {
                                        this.skipManagerApprovalMessage = "only_one_default_role";
                                    }
                                }
                            }
                            if(this.skipManagerApprovalMessage!=""){
                                break;
                            }
                            }
                    }
                })
            }
        //    ***************************************** 
            this.ApplicationFormDetails.validate = this.ApplicationForm.valid;
        });

        this.ApplicationForm.get('managerData').valueChanges.subscribe(data => {
            if (data != null && data.length < 2) {
                this.managersMessage = "atleast_two_mgrs";
                this.managersFlag = false;
            } else if (data.length >= 2) {
                this.managersMessage = "";
                this.managersFlag = true;
            }
        });

        this.ApplicationForm.get('multipleRole').valueChanges.subscribe(data => {
            console.log(data)
            if (data != null && !data && this.allowMultipleRolesFlag) {
                this.createDefaultRoles();
            }
        });

        this.ApplicationForm.get('skipManagerApproval').valueChanges.subscribe(data => {
            if (data != null && !data) {
                this.createDefaultRoles();
            }
        });
    }

// ********************************
setApplicationRoleSpecific(){
    console.log(this.selectedContries);
    let formdata = this.ApplicationForm.getRawValue();
    console.log(formdata)
        if(this.forSpecificCountry){
            formdata.countries.forEach((element,index) => {
                this.ApplicationFormDetails['applicationRoles'].push ({
                    country:this.selectedContries[index].id,
                    roles:element.countryName
                    // country:this.selectedContries[index],
                    // roles:element.countryName
                })
            });


        } else{

            this.ApplicationFormDetails.applicationRoles=[];
            this.ApplicationFormDetails['applicationRoles'].push ({
                country:"all",
                roles:formdata.applicationRoles
            })
        }
}

   forSpecificCountry=false

    createRoles(rolesData, isAssigned): void {
        if(!this.forSpecificCountry){
            for (let roleDataIndex in rolesData) {
                rolesData[roleDataIndex]['isAssigned'] = isAssigned;
                this.onAddRoleProperty(rolesData[roleDataIndex]);
                // this.onAddRoleProperty(rolesData[0].roles[roleDataIndex]);
            }
        }else{
            // rolesData.forEach((element,index) => {
            //     console.log(element)
            //     this.onAddCountriestoForm(element);  
            // });
            this.onAddCountriestoForm(rolesData,isAssigned);  

        }
    }
    onAddCountriestoForm(data,isAssigned){
        let contries=[];
        for(var i=0;i<data.length;i++){

            if(contries.length==0){
                contries.push({"countryId":data[i].country,"countryName":data[i].countryName,"roles":[{"id":data[i].id,"name":data[i].name,"ldapRoleId":data[i].ldapRoleId,"defaultRole":data[i].defaultRole,"isAssignFlag":isAssigned}]})
            }else{
                var valueArr:any = contries.map(function(item){ return item.countryId });
                if(!valueArr.includes(data[i].country)){
                    contries.push({"countryId":data[i].country,"countryName":data[i].countryName,"roles":[{"id":data[i].id,"name":data[i].name,"ldapRoleId":data[i].ldapRoleId,"defaultRole":data[i].defaultRole,"isAssignFlag":isAssigned}]})
                }else{
                    for(var j=0;j<contries.length;j++){
                        if(data[i].country == contries[j].countryId){
                            contries[j].roles.push({"id":data[i].id,"name":data[i].name,"ldapRoleId":data[i].ldapRoleId,"defaultRole":data[i].defaultRole,"isAssignFlag":isAssigned})
                        }
                    }
                }
            }

        }
        for(var k=0;k<contries.length;k++){
            let fg = this.formBuilder.group({
                'countryName': this.formBuilder.array([]),
            });
            (<FormArray>this.ApplicationForm.get('countries')).push(fg);
            this.selectedContries.push({'id':contries[k].countryId,"name":contries[k].countryName,"isAssignFlag":isAssigned});

            contries[k]['roles'].forEach((element,index) => {
                    let newGroup = this.formBuilder.group({
                        id: this.formBuilder.control(element.id ? element.id : null),
                        name: this.formBuilder.control(element.name ? element.name : null, [Validators.required]),
                        ldapRoleId: this.formBuilder.control(element.ldapRoleId ? element.ldapRoleId : null, [Validators.required]),
                        defaultRole: this.formBuilder.control(element.defaultRole ? element.defaultRole : false),
                        isAssignFlag: this.formBuilder.control(element.isAssignFlag ? element.isAssignFlag : false)
                    });
        
                    (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
                    .controls[this.selectedContries.length-1]).controls['countryName']).push(newGroup);
                });
        }

        // data.roles.forEach((element,index) => {
        //     console.log(element)
        //     let newGroup = this.formBuilder.group({
        //         id: this.formBuilder.control(element.id ? element.id : null),
        //         name: this.formBuilder.control(element.name ? element.name : null, [Validators.required]),
        //         ldapRoleId: this.formBuilder.control(element.ldapRoleId ? element.ldapRoleId : null, [Validators.required]),
        //         defaultRole: this.formBuilder.control(element.defaultRole ? element.defaultRole : false),
        //         isAssignFlag: this.formBuilder.control(element.isAssigned ? element.isAssigned : false)
        //     });

        //     (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
        //     .controls[this.selectedContries.length-1]).controls['countryName']).push(newGroup);
        // });
    }

// **********************************

    public onAddRoleProperty(data?: any): void {
        const arrayControl = <FormArray>this.ApplicationForm.controls['applicationRoles'];
        let newGroup;
        if (data) {
            newGroup = this.formBuilder.group({
                id: this.formBuilder.control(data.id ? data.id : null),
                name: this.formBuilder.control(data.name ? data.name : null, [Validators.required]),
                ldapRoleId: this.formBuilder.control(data.ldapRoleId ? data.ldapRoleId : null, [Validators.required]),
                defaultRole: this.formBuilder.control(data.defaultRole ? data.defaultRole : false),
                isAssignFlag: this.formBuilder.control(data.isAssigned ? data.isAssigned : false)
            });
        } else {
            newGroup = this.formBuilder.group({
                id: this.formBuilder.control(null),
                name: this.formBuilder.control(null, [Validators.required]),
                ldapRoleId: this.formBuilder.control(null, [Validators.required]),
                defaultRole: this.formBuilder.control(false),
                isAssignFlag: this.formBuilder.control(false)
            });
        }

        arrayControl.push(newGroup);

    }

    onlyOneDefault(index: number, value: any): void {
        if (this.skipManagerApprovalFlag && !this.allowMultipleRolesFlag) {
            this.createDefaultRoles();
        }
    }

    createDefaultRoles() {
        if(!this.forSpecificCountry){
            const arrayControl = <FormArray>this.ApplicationForm.controls['applicationRoles'];
            for (let index1 in arrayControl.controls) {
                const groupControl = <FormGroup>arrayControl.controls[index1];
                groupControl.controls['defaultRole'].setValue(false);
                groupControl.controls['defaultRole'].updateValueAndValidity();
            }
        }else{
            const arrayControl = <FormArray>this.ApplicationForm.controls['countries'];            
            for(let index2 in arrayControl.controls){
                this.createDefaultRolesCountSpecific(index2);
            }
            this.calculateErrorForRDefault();
        }
    }

    onDeleteRoleProperty(index: number): void {
        const arrayControl = <FormArray>this.ApplicationForm.controls['applicationRoles'];
        arrayControl.removeAt(index);
    }

    public saveApplicationData() {
        this.setApplicationRoleSpecific();
        /**************************/
        var requestData = JSON.parse(JSON.stringify(this.ApplicationFormDetails));
        delete requestData.countries;
        var applicationRoles=[];
        for(let i in requestData.applicationRoles) {
            for(let j in requestData.applicationRoles[i].roles) {
                requestData.applicationRoles[i].roles[j].country=requestData.applicationRoles[i].country;
                applicationRoles.push(requestData.applicationRoles[i].roles[j]);
            }
        }
        delete requestData.applicationRoles;
        requestData.applicationRoles=applicationRoles;
        if(!requestData.skipManagerApproval){
            requestData.applicationRoles.forEach((element)=>{
                element.defaultRole = false;
            })
        }

        /**************************/
        this.httpService.postRequest(requestData, 'applicationOperationApi/v1/createApplication').subscribe(
            res => {
                this.saveApplicationResponse(res);
            },
            err => {
                this.httpService.onEnd();
            }
        );
    }

    public saveApplicationResponse(res) {
        if (res) {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            if (this.id != null && this.id != undefined) {
                this.dialogRef.componentInstance.msg = "Application updated successfully.";
            } else {
                this.dialogRef.componentInstance.msg = "Application added successfully.";
            }
            this.dialogRef.afterClosed().subscribe(result => {
                window.location.href = '#/app/application-management/list';
            });
        } else if (res.errorStatus == 'Fail') {
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'save_failed';
            this.httpService.onEnd();
        }
    }

    copyToClipboard() {
        var textArea = document.createElement("textarea");
        textArea.style.position = 'fixed';
        textArea.style.top = '-999px';
        textArea.style.left = '-999px';
        textArea.style.width = '2em';
        textArea.style.height = '2em';
        textArea.style.padding = '0';
        textArea.style.border = 'none';
        textArea.style.outline = 'none';
        textArea.style.boxShadow = 'none';
        textArea.style.background = 'transparent';

        textArea.value = window.location.origin + "/#/registration/apps/" + this.id;
        document.body.appendChild(textArea);
        textArea.select();

        try {
            document.execCommand('copy');
        } catch (err) {
            console.log('unable to copy');
        }
        document.body.removeChild(textArea);
    }

    ngOnInit() {
        this.buildForm();
        if (this.id == null || this.id == undefined) {
            this.onAddRoleProperty();
        }

        var temp_settings = {singleSelection: false,text:"",labelKey: "name",selectAllText:"",unSelectAllText:"",classes:"myclass custom-class"};
        this.translate.get('Assign Manager').subscribe((res: string) => {temp_settings.text = res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('select_all').subscribe((res: string) => {temp_settings.selectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });
        this.translate.get('unselect_all').subscribe((res: string) => {temp_settings.unSelectAllText=res;
            if(temp_settings.text&&temp_settings.selectAllText&&temp_settings.unSelectAllText) {this.settings=temp_settings;}
        });

    }

    public getCountries(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/countriesForAdmin').subscribe(
            res => { 
                this.saveCountries(res);
             },
            err => { this.httpService.onEnd(); }
        );
    }

    public saveCountries(res){
        if(res && res.items){
            this.countries = res.items;
        }
    }

    countSpecificFun(event){
      const arrayControl = <FormArray>this.ApplicationForm.controls['applicationRoles'];
      if(!event.checked){
          this.forSpecificCountry = false;
          while ((<FormArray>this.ApplicationForm.controls['countries']).controls.length !==0) {
              (<FormArray>this.ApplicationForm.controls['countries']).removeAt(0);
            }
            this.selectedContries=[];
            this.onAddRoleProperty();
        }else if(event.checked){
            this.forSpecificCountry = true;
            while ((<FormArray>this.ApplicationForm.controls['applicationRoles']).controls.length !==0) {
                (<FormArray>this.ApplicationForm.controls['applicationRoles']).removeAt(0);
            }
       }

    }

    selectedContries:any=[]
    onCountryChange(contId){
        var valueArr = this.selectedContries.map(function(item){ return item.name });
        let contry = contId.source.selected._element.nativeElement.innerText.trim();
        let id= contId.value;
        let country = contId.source.selected._element.nativeElement.innerText.trim();
            let fg = this.formBuilder.group({
                'countryName': this.formBuilder.array([]),
            });
            if(valueArr.includes(contry)==false){
                this.selectedContries.push({"id":id,"name":contry,"isAssignFlag":false});
                (<FormArray>this.ApplicationForm.get('countries')).push(fg);
                this.rolesAddForSelectedCountries(this.selectedContries.length-1);
            }
            this.calculateErrorForRDefault();
            setTimeout(() => {
                this.countrySelect.writeValue(null)                
            }, 1000);

    }

    rolesAddForSelectedCountries(index){
        let newGroup = this.formBuilder.group({
            id: this.formBuilder.control(null),
            name: this.formBuilder.control(null, [Validators.required]),
            ldapRoleId: this.formBuilder.control(null, [Validators.required]),
            defaultRole: this.formBuilder.control(false),
            isAssignFlag: this.formBuilder.control(false)
        });
        (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
            .controls[index]).controls['countryName']).push(newGroup);
    }

    deleteCountry(index){
        const arrayControl = <FormArray>this.ApplicationForm.controls['countries'];
        arrayControl.removeAt(index);
        this.selectedContries.splice(index,1);
        this.countryWiseDefaults.splice(index,1);
    }
    onDeleteRolePropertySelected(cIndex,index) {
        const arrayControl = <FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
        .controls[cIndex]).controls['countryName'];
        
        arrayControl.controls[index].get('defaultRole').value ? this.countryWiseDefaults[cIndex] = false : null;
        arrayControl.removeAt(index);

    }

    createDefaultRolesCountSpecific(countIndex,index?) {
        const arrayControl = (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
            .controls[countIndex]).controls['countryName']);
            for (let index1 in arrayControl.controls) {
                const groupControl = <FormGroup>arrayControl.controls[index1];
                groupControl.controls['defaultRole'].setValue(false);
                groupControl.controls['defaultRole'].updateValueAndValidity();  
            }
    }

    onlyOneDefaultSpecific(countIndex,index) {
        if(!this.allowMultipleRolesFlag){
            const arrayControl = (<FormArray>(<FormGroup>(<FormArray>this.ApplicationForm.controls['countries'])
            .controls[countIndex]).controls['countryName']);
            for (let index1 in arrayControl.controls) {
                if(index1 != index){
                    const groupControl = <FormGroup>arrayControl.controls[index1];
                    groupControl.controls['defaultRole'].setValue(false);
                }
            }
        }
        this.calculateErrorForRDefault();
    }
    calculateErrorForRDefault(){
        this.countryWiseDefaults=[];
        setTimeout(()=>{
            var data = this.ApplicationForm.get('countries').value;
            let defaultFlag=false;
            for(var i=0;i<data.length;i++){
                defaultFlag =false;
                for(var j=0;j<data[i].countryName.length;j++){
                    if(data[i].countryName[j].defaultRole){
                        defaultFlag = true;
                    }
                }
                if(defaultFlag){
                    this.countryWiseDefaults.push(true);
                }else{
                    this.countryWiseDefaults.push(false);
                }
            }
            console.log(this.countryWiseDefaults)
        })      
    }
//    ******************************************************* 
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/system-level-setting/applicationManagement/addApplication/addApplication.component.ts